import {Model} from "ords/dist/model/model";

export class ModuleDate extends Model {
    userHasRegistration(user_id) {
        for(const moduleUser of this.module_users){
            if (moduleUser.user_id === user_id) {
                return true;
            }
        }
        return false;
    }

    findModuleUserByUserId(user_id) {
        if(this.module_users && this.module_users.length > 0){
            for(const moduleUser of this.module_users){
                if (moduleUser.user_id === user_id) {
                    return moduleUser;
                }
            }
        }

        return null;
    }

    findRegister(date, user_id){
        for (let user of date.module_users){
            if(user.user_id === user_id){
                return user
            }
        }

        return null;
    }
}

export const ModuleDateModelConfig = {
    name: 'module_dates',
    model: ModuleDate,
    relations: [
        {name: 'module_users', model_name: 'module_users', type: 'hasMany'},
        {name: 'module_period', model_name: 'module_period', type: 'hasOne'},
    ]

}
